import { createPortal } from 'react-dom'

interface ConfirmModalProps {
  icon: string
  iconBg: string
  title: string
  body: string
  extra?: string
  cancelLabel?: string
  confirmLabel: string
  confirmClass: string
  loading?: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function ConfirmModal({
  icon,
  iconBg,
  title,
  body,
  extra,
  cancelLabel = 'Cancel',
  confirmLabel,
  confirmClass,
  loading,
  onCancel,
  onConfirm,
}: ConfirmModalProps) {
  return createPortal(
    <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center p-6" onMouseDown={onCancel}>
      <div
        className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl ring-1 ring-black/5"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="text-center mb-5">
          <div className={`w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-3 ${iconBg}`}>
            <i className={`${icon} text-xl`} />
          </div>
          <h3 className="font-bold text-lg text-slate-900">{title}</h3>
          <p className="text-sm text-slate-500 mt-2">{body}</p>
          {extra && <p className="text-sm text-danger-600 font-medium mt-2">{extra}</p>}
        </div>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 py-3 rounded-lg border border-slate-300 text-[15px] font-medium text-slate-600 hover:bg-slate-50 transition-colors"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 py-3 rounded-lg text-[15px] font-medium text-white transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${confirmClass}`}
          >
            {loading ? 'Please wait...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
